import { Divider, TextButton, Modal, Box } from '@wix/design-system';
import * as React from 'react';
import s from './category-header-mobile.scss';
import { SubCategoriesSelectorModalMobile } from './sub-categories-selector-modal-mobile';
import type { ISubCategoriesSelectorProps } from '../sub-categories-selector';
import { SelectorTagMobile } from './selector-tag-mobile';
import { config } from '../../../config';
import type { WithTranslation as WithTranslationProps } from 'react-i18next';
import { withTranslation } from '../../../component-decorators/with-translation';

export interface ISubCategoriesSelectorMobileProps
  extends ISubCategoriesSelectorProps,
    Partial<WithTranslationProps> {}

@withTranslation
export class SubCategoriesSelectorMobile extends React.Component<
  ISubCategoriesSelectorMobileProps,
  any
> {
  constructor(props) {
    super(props);
    this.state = {
      isModalOpened: false,
      checkedSubCategories: [],
    };
    this.setCheckedSubCategories = this.setCheckedSubCategories.bind(this);
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }
  openModal = () => this.setState({ isModalOpened: true });
  closeModal = () => this.setState({ isModalOpened: false });
  setCheckedSubCategories = (subCategories) => {
    this.setState({ checkedSubCategories: subCategories });
  };

  render() {
    const { subCategories, categoryName, name, t } = this.props;
    const { isModalOpened, checkedSubCategories } = this.state;
    return (
      <div
        data-testid="sub-categories-selector-mobile"
        className={s.subCategoriesSelector}
      >
        {checkedSubCategories && checkedSubCategories.length ? (
          <div className={s.selectorsChecked}>
            {checkedSubCategories.map((subCategory) => {
              return (
                <SelectorTagMobile
                  name={subCategory.name}
                  key={subCategory.slug}
                />
              );
            })}
          </div>
        ) : (
          <>
            <SelectorTagMobile
              name={t('category.filter-subcategory.all')}
              slug="all"
            />
            <div className={s.selectorsDividerAll}>
              <Divider direction="vertical" skin="light" />
            </div>
          </>
        )}
        <TextButton
          skin="light"
          size="small"
          weight="normal"
          onClick={this.openModal}
          underline="always"
        >
          {t('category-header-mobile.filter-subcategory.title')}
        </TextButton>
        <Modal
          isOpen={isModalOpened}
          onRequestClose={this.closeModal}
          scrollableContent={true}
        >
          <SubCategoriesSelectorModalMobile
            subCategories={subCategories}
            checkedSubCategories={this.state.checkedSubCategories}
            setCheckedSubCategories={this.setCheckedSubCategories}
            categoryName={categoryName}
            name={name}
            closeModal={this.closeModal}
          />
        </Modal>
      </div>
    );
  }
}
